import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from '../pop-denied-access'

let guard = () => new Promise((resolve, reject) => {
  return (
    find(store.getters['auth/abilities'], ability =>
      ability.name === 'transfer-assets-between-clients' || 'transfer-assets-within-client' &&
      ability.entity_type === 'Billow\\Models\\Asset'
    )
  ) ? resolve() : accessDeniedToaster(reject, {
    name: 'dashboard'
  })
})

export default {
  name: 'transfer-assets-between-zones',
  run: guard
}